class ScrollToTop extends HTMLElement {
  constructor() {
    super();
    this._btn = null;
    this._visible = false;
    this._onScroll = this._onScroll.bind(this);
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    this._btn = this.querySelector('button');
    if (!this._btn) return;

    window.addEventListener('scroll', this._onScroll, { passive: true });
    this._btn.addEventListener('click', this._onClick);

    this._onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    if (this._btn) this._btn.removeEventListener('click', this._onClick);
  }

  _onScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.documentElement.scrollHeight;
    const winHeight = window.innerHeight;
    const scrolled = (scrollTop + winHeight) / docHeight * 100;
    const shouldBeVisible = scrolled >= 80;
    
    if (shouldBeVisible !== this._visible) {
      this.classList.toggle('active', shouldBeVisible);
      this._visible = shouldBeVisible;
    }
  }

  _onClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

customElements.define('scroll-to-top', ScrollToTop);
